module.exports = __webpack_public_path__ + "static/media/XVh.a99542c6.png";